import React from "react";
import { IsOnlineProvider } from "@dashboard/features/online";
import { ErrorsProvider } from "@dashboard/features/errors/ErrorsProvider";
import { AuthProvider } from "@workspace/ui/hooks";
import { LicenseProvider } from "@dashboard/license/LicenseProvider";
import { GlobalPendingSync } from "@dashboard/components/GlobalPendingSync";

export interface ProvidersProps {
  children?: React.ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <ErrorsProvider>
      <IsOnlineProvider>
        <AuthProvider>
          <GlobalPendingSync />
          <LicenseProvider>{children}</LicenseProvider>
        </AuthProvider>
      </IsOnlineProvider>
    </ErrorsProvider>
  );
}
